import { FuelButton, FuelSign, FuelTypography } from '@frete.com/fuel-react';
import { FuelFlex, FuelSpacer } from '@frete.com/fuel-station-react';
import { inviteDriverMessage } from 'components/States/constants';
import { dsTheme } from 'constants/styled.contants';
import { useAmplitude } from 'hooks/useAmplitude';
import { useAppContext } from 'hooks/useAppContext';
import { useTracking } from 'hooks/useTracking';
import React from 'react';
import { useParams } from 'react-router-dom';

const Empty = () => {
  const {
    state: {
      deviceSize: { isDesktop },
      searchTruckers: { term },
    },
  } = useAppContext();

  const { sendAmplitude } = useAmplitude();
  const { sendTracking } = useTracking();
  const { freightId } = useParams();

  const handleInviteDriver = () => {
    sendAmplitude('trucker_listing_invitation_sent', {
      source: 'convidar-motorista',
      type: 'nao-disponivel',
      freightCode: freightId,
      value: term,
    });
    sendTracking({
      url: window.location.href,
      referrer: document.referrer,
      event: {
        name: 'trucker_listing_invitation_sent',
      },
      data: {
        source: 'convidar-motorista',
        type: 'nao-disponivel',
        freightId: `hashed|${freightId}`,
        value: term,
      },
    });

    window.open(encodeURI(`https://api.whatsapp.com/send?text=${inviteDriverMessage}`), '_blank');
  };

  return (
    <FuelFlex
      defaultProps={{
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        customMargin: `${dsTheme.spacing.km16} 0 0`,
      }}
      testId="search-empty-state"
    >
      <FuelSign size="medium" icon="search" />
      <FuelSpacer orientation="vertical" y="km8" />
      <FuelTypography size="heading-sm" weight="bold" tag="h4" color="neutral-strong">
        Nenhum motorista encontrado
      </FuelTypography>

      <FuelFlex defaultProps={{ alignItems: 'center', justifyContent: 'center' }}>
        <FuelTypography size="body-sm">
          Buscamos em nossa base e não encontramos nenhum perfil cadastrado.
        </FuelTypography>
      </FuelFlex>

      {!isDesktop && (
        <FuelFlex defaultProps={{ customMargin: `${dsTheme.spacing.km12} 0 0`, width: '80%' }}>
          <FuelButton variant="primary" size="large" fullWidth onClick={handleInviteDriver}>
            Convidar motorista
          </FuelButton>
        </FuelFlex>
      )}
    </FuelFlex>
  );
};

export default Empty;
